module.exports = __webpack_public_path__ + "static/sparkle-white-2036b5aecb26f7bb03bccc1e55595b8f.png";